import Vue from 'vue'

Vue.filter('toEUR', (value: string) => {
  if (value === null) {
    return ''
  }
  return '€ ' + parseFloat(value).toFixed(2).replace('.', ',').replace(',00', '').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
})
